import {
  CalendarClockIcon,
  ClipboardListIcon,
  FlaskConicalIcon,
  RouteIcon,
  SearchCheckIcon,
  SettingsIcon,
} from 'lucide-react';

export const problems = [
  'Not sure what to test—or what the results mean?',
  'Confused by products with similar names and different instructions?',
  'Unsure what to check when the water changes?',
  'Missing a clear maintenance routine?',
];

export const methodSteps = ['Identify', 'Test', 'Interpret', 'Act', 'Recheck', 'Record'];

export const benefits = [
  {
    icon: SettingsIcon,
    title: 'Understand Your Equipment',
    text: 'Learn what the main components do.',
  },
  {
    icon: FlaskConicalIcon,
    title: 'Make Sense of Water Testing',
    text: 'Understand the terms and record your results.',
  },
  {
    icon: RouteIcon,
    title: 'Build Your Maintenance Routine',
    text: 'Organize cleaning and regular checks.',
  },
  {
    icon: SearchCheckIcon,
    title: 'Investigate Common Problems',
    text: 'Learn what to check before choosing a treatment.',
  },
  {
    icon: CalendarClockIcon,
    title: 'Prepare for Changing Conditions',
    text: 'Plan for busy pool days, weather changes, and seasonal care.',
  },
  {
    icon: ClipboardListIcon,
    title: 'Keep Useful Records',
    text: 'Use printable checklists and maintenance worksheets.',
  },
];

// Replace these with real screenshots from the final PDF before publishing.
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/60d23eab-46bb-45d0-bdb1-6bd42f8dd261.jpg',
    title: 'Circulation diagram',
    caption: 'See how water moves through your pump, filter, and returns.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/e7034f3d-62b9-47c1-8bb9-2f927a872208.jpg',
    title: 'Water testing log',
    caption: 'Record each reading and spot changes over time.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/7788cdc1-46ff-4730-b159-cf97bcb3924d.jpg',
    title: 'Green or cloudy water checks',
    caption: 'Follow a step-by-step path before choosing a treatment.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/b0949a07-63f2-4adc-a14c-84d9e4a72e7f.jpg',
    title: 'Printable checklist',
    caption: 'Daily, weekly, and monthly tasks on one page.',
  },
];

export const bonuses = [
  {
    title: 'The First 7 Days Pool Starter Plan',
    text: 'Start with a seven-day learning roadmap that helps you understand your pool and organize your first routine.',
    cover: 'https://cdn.magicpatterns.com/uploads/qfiH4eAqBuQpWwB8gaQApL/img_pool_1.webp',
  },
  {
    title: 'The Pool Shopping Companion',
    text: 'Choose suitable tools, understand product labels, and prepare a more informed shopping list.',
    cover: 'https://cdn.magicpatterns.com/uploads/fA3EVJLcre93cyX8T6TnL8/img_2_pool.webp',
  },
  {
    title: 'The Vacation Pool Handover Kit',
    text: 'Leave clear care instructions, visit records, and contact details for the person looking after your pool.',
    cover: 'https://cdn.magicpatterns.com/uploads/kYFLxw4FKtV4Ev3UcA2Awp/img_3_pool.webp',
  },
  {
    title: 'The Pool Party Prep & Reset Playbook',
    text: 'Organize your checks and cleaning before and after a busy pool day.',
    cover: 'https://cdn.magicpatterns.com/uploads/rm4q71ggnu9XDfpygfHKCY/img_4_pool.webp',
  },
  {
    title: 'The Pool Cost Control Workbook',
    text: 'Track purchases, compare service quotes, and plan your pool-care spending.',
    cover: 'https://cdn.magicpatterns.com/uploads/qoaSios9MudjxUCenaQect/img_5_pool.webp',
  },
];

export const packItems = [
  'Pool Care Made Simple — Main Guide',
  'All 5 Bonus PDFs',
  'Printable Checklists & Worksheets',
  'One-Time Payment',
  '10-Day Money-Back Guarantee',
];

export const faqs = [
  {
    q: 'Is this suitable for beginners?',
    a: 'Yes. The guide explains the basics in plain English and introduces technical terms as you go.',
  },
  {
    q: 'Does it cover saltwater pools?',
    a: 'Yes. It includes an introduction to saltwater chlorine generators and explains where model-specific instructions are needed.',
  },
  {
    q: 'What will I receive?',
    a: 'The main guide and five bonus PDFs, including printable checklists and worksheets.',
  },
  {
    q: 'Is this a physical book or a video course?',
    a: 'It’s a digital PDF bundle. No physical products or videos are included.',
  },
  {
    q: 'Can I use it outside the United States?',
    a: 'The guide uses liters and US gallons where relevant. Always follow your local requirements and the instructions for your equipment and products.',
  },
  {
    q: 'Does this replace professional repairs?',
    a: 'The pack focuses on homeowner maintenance and basic checks. Electrical, structural, and other specialized repairs require qualified help.',
  },
  {
    q: 'Is this a subscription?',
    a: 'No. The complete pack costs $33 USD as a one-time payment.',
  },
  {
    q: 'What if the content isn’t right for me?',
    a: 'Contact us within 10 days of purchase to request a refund.',
  },
];
